export const employeeActivityReportList = "EMPLOYEE_ACTIVITY_REPORT_LIST";
export const employeeProductivityReportList = "EMPLOYEE_PRODUCTIVITY_REPORT_LIST";
export const industrialReportList = "INDUSTRIAL_REPORT_LIST";
export const planningReportList = "PLANNING_REPORT_LIST";
export const usersSystemReportList = "USERS_SYSTEM_REPORT_LIST";
export const masterChangeLogReportList = "MASTER_CHANGE_LOG_REPORT_LIST";
export const employeeEfficiencyReportList = "EMPLOYEE_EFFICIENCY_REPORT_LIST";